import axios, { AxiosError } from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_APP_BACKEND_URL || "",
});

api.interceptors.request.use(
  async (config) => {
    const access_token = localStorage.getItem("access_token");

    if (access_token) {
      config.headers["Authorization"] = `Bearer ${access_token}`;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

api.interceptors.response.use(
  async (config) => {
    return config;
  },
  async (error: AxiosError) => {
    if (
      Number(error?.response?.status) === 401 &&
      !error.config?.url?.includes("/login")
    ) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/";
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export { api };
